export default class TextValue {
  text!: string | null;
  language!: string | null;
  type!: string | null;
  preference!: number | null;
  alternativeId!: string | null;

  constructor() {
    this.text = null;
    this.language = null;
    this.type = null;
    this.preference = null;
    this.alternativeId = null;
  }
}
